import { render, staticRenderFns } from "./ScreenshotReviewModal.vue?vue&type=template&id=32e7a84a&scoped=true"
import script from "./ScreenshotReviewModal.vue?vue&type=script&lang=js"
export * from "./ScreenshotReviewModal.vue?vue&type=script&lang=js"
import style0 from "./ScreenshotReviewModal.vue?vue&type=style&index=0&id=32e7a84a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e7a84a",
  null
  
)

export default component.exports